// extracted by mini-css-extract-plugin
export default {"page":"Page_page__mmn9zYmy","title":"Page_title__1OiLq2q8"};